import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Target, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { TossDataInputTab } from '../components/admin/strategy/TossDataInputTab';
import { TossAnalysisTab } from '../components/admin/strategy/TossAnalysisTab';
import { SelfAnalysisTab } from '../components/admin/strategy/SelfAnalysisTab';
import { ComprehensiveDashboardTab } from '../components/admin/strategy/ComprehensiveDashboardTab';
import { ReportDashboardTab } from '../components/admin/strategy/ReportDashboardTab';

type StrategyTab = 'tossInput' | 'tossAnalysis' | 'selfAnalysis' | 'dashboard' | 'report';

const TAB_LABELS: Record<StrategyTab, string> = {
  tossInput: '토스 데이터 입력',
  tossAnalysis: '토스 데이터 분석',
  selfAnalysis: '자체 데이터 분석',
  dashboard: '종합 대시보드',
  report: '보고용 대시보드',
};

const AdminStrategyPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<StrategyTab>('tossInput');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-green-50/30">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* 헤더 */}
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/admin/dashboard')}
              className="flex items-center gap-1"
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-green-400 to-emerald-500 rounded-xl flex items-center justify-center shadow-lg">
                <Target className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">전략 관리</h1>
                <p className="text-xs text-gray-500">토스 데이터 입력 + 분석 + 종합 대시보드</p>
              </div>
            </div>
          </div>
        </div>

        {/* 탭 네비게이션 */}
        <div className="flex flex-wrap gap-2 mb-6">
          {(Object.keys(TAB_LABELS) as StrategyTab[]).map(tab => (
            <Button
              key={tab}
              variant={activeTab === tab ? 'default' : 'outline'}
              size="sm"
              onClick={() => setActiveTab(tab)}
            >
              {TAB_LABELS[tab]}
            </Button>
          ))}
        </div>

        {/* 탭 컨텐츠 */}
        {activeTab === 'tossInput' && <TossDataInputTab />}
        {activeTab === 'tossAnalysis' && <TossAnalysisTab />}
        {activeTab === 'selfAnalysis' && <SelfAnalysisTab />}
        {activeTab === 'dashboard' && <ComprehensiveDashboardTab />}
        {activeTab === 'report' && <ReportDashboardTab />}
      </div>
    </div>
  );
};

export default AdminStrategyPage;
